<template>
    <v-container fluid style="margin: 60px 10%">
        <v-row>
            <v-col cols='12' align='center'>
                <v-btn x-large style="min-width:20%!important" color="primary white--text" class="my-5" @click="abrirDialog()">Crear Cupón</v-btn>
                <v-data-table
                :items="cupones"
                :headers="headerCupones">
                <template v-slot:item.acciones="{item}">
                    <v-icon color="primary" @click="eliminarCupon(item)">fas fa-trash</v-icon>
                </template>
                </v-data-table>
            </v-col>
            <v-dialog v-model="dialog">
                <v-card v-if="cupon">
                    <v-card-title>
                        <v-container>
                            <v-row>
                                <v-col cols="12" align="center">
                                    <h1>Crear Cupón</h1>
                                </v-col>
                                <v-col cols="12" align="center">
                                    <span>CÓDIGO {{cupon.uid}}</span>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field solo v-model="cupon.cantidad" type="number" label="Cantidad" hint="Cantidad" persistent-hint />
                                </v-col>
                                <v-col cols="12">
                                    <v-select solo label="Tipo de Cupón" :items="tiposCupon" v-model="tipoCupon" hint="Tipo de Cupón" persistent-hint />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field solo v-if="tipoCupon === 'Porcentaje'" v-model="cupon.porcentaje" type="number" min="0" max="100" label="Porcentaje" hint="Porcentaje" persistent-hint />
                                    <v-text-field solo v-if="tipoCupon === 'Valor'" v-model="cupon.valor" type="number" label="Valor (COP)" hint="Valor (COP)" persistent-hint />
                                </v-col>
                                <v-col cols="12" align="center">
                                    <v-btn outlined style="border: 2px solid;" x-large class="ma-3">Cerrar</v-btn>
                                    <v-btn x-large class="ma-3" color="primary white--text" @click="crearCupon()">Crear Cupón</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-title>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import * as faker from 'faker'
import { mapMutations } from 'vuex'
export default {
  name: 'AdministracionCupones',
  mounted () {
    firebase.firestore().collection('cupones').get().then(info => {
      for (let i = 0; i < info.docs.length; i++) {
        this.cupones.push(info.docs[i].data())
      }
    })
  },
  data () {
    return {
      cupones: [],
      cupon: null,
      tipoCupon: null,
      tiposCupon: ['Porcentaje', 'Valor'],
      headerCupones: [
        { text: 'Codigo', value: 'uid', align: 'center' },
        { text: 'Cantidad', value: 'cantidad', align: 'center' },
        { text: 'Usados', value: 'usados', align: 'center' },
        { text: 'Valor', value: 'valor', align: 'center' },
        { text: 'Porcentaje', value: 'porcentaje', align: 'center' },
        { text: 'Acciones', value: 'acciones', align: 'center' }
      ],
      dialog: false

    }
  },
  methods: {
    ...mapMutations(['setAlerta', 'setTextoAlerta']),
    abrirDialog () {
      this.cupon = {
        uid: faker.random.alphaNumeric(12).toUpperCase(),
        cantidad: 1,
        porcentaje: null,
        usados: 0,
        valor: null
      }
      this.dialog = true
    },
    crearCupon () {
      if (this.tipoCupon === 'Porcentaje') {
        if (this.cupon.porcentaje < 1 || this.cupon.porcentaje > 100 || !this.cupon.porcentaje) {
          this.setAlerta()
          this.setTextoAlerta('El porcentaje debe ser mayor a 0 y menor que 100')
          return
        }
      }
      if (this.tipoCupon === 'Valor' && !this.cupon.valor) {
        this.setAlerta()
        this.setTextoAlerta('Debes introducir un valor para el cupón')
        return
      }
      firebase.firestore().collection('cupones').doc(this.cupon.uid).set(this.cupon).then(() => {
        this.cupones.push(this.cupon)
        this.setAlerta()
        this.setTextoAlerta('Cupón creado con éxito')
        this.dialog = false
      })
    },
    eliminarCupon (cupon) {
      const index = this.cupones.indexOf(cupon)
      firebase.firestore().collection('cupones').doc(cupon.uid).delete().then(() => {
        this.cupones.splice(index, 1)
        this.setAlerta()
        this.setTextoAlerta('Cupón eliminado con éxito')
      })
    }
  },
  watch: {
    tipoCupon (n, v) {
      if (n === 'Porcentaje') {
        this.cupon.valor = null
      }
      if (n === 'Valor') {
        this.cupon.porcentaje = null
      }
    }
  }
}
</script>
